module.exports = __webpack_public_path__ + "img/fishing-1.a4d3b404.jpg";